/* eslint-disable no-unused-vars */
import React, { FC, memo, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

const useStyles = makeStyles({
  root: {}
});

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: (value?: string) => void;
  options: string[];
}

const Component: FC<Props> = ({ open, onClose, onConfirm, options }) => {
  const classes = useStyles();
  const [selectedOption, setSelectedOption] = useState<string | null>(
    options[0]
  );

  const handleConfirm = () => {
    onConfirm(selectedOption || '');
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth={'sm'}>
      <DialogTitle>Choose branch origin (Required)</DialogTitle>
      <DialogContent>
        <Autocomplete
          options={options}
          value={selectedOption}
          onChange={(event, newValue) => setSelectedOption(newValue)}
          renderInput={(params) => (
            <TextField {...params} label="Choose" variant="outlined" />
          )}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="default">
          Cancel
        </Button>
        <Button onClick={handleConfirm} color="primary" variant="contained">
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const RmaUpdateBranchDialog = memo(Component);
